import { useQuery } from '@tanstack/react-query'
import { useMedia } from 'react-use'
import queryClient from '../queryClient'
import useUserPreference, { UserPreference } from './useUserPreference'

const THEME_QUERY_OPTIONS_KEY = ['JK_USER_PREFERS_THEME']

export default function useTheme() {
	const [userPreferenceTheme = 'LIGHT', setUserPreferenceTheme] = useUserPreference('theme')
	const { data: theme } = useQuery({
		queryKey: THEME_QUERY_OPTIONS_KEY,
		initialData: userPreferenceTheme,
	})
	const setTheme = (nextTheme: UserPreference['theme']) => {
		queryClient.setQueryData(THEME_QUERY_OPTIONS_KEY, nextTheme)
		setUserPreferenceTheme(nextTheme)
	}
	return [theme, setTheme] as const
}

export function useIsDarkTheme() {
	const isDarkMode = useMedia('(prefers-color-scheme: dark)', false)
	const [theme] = useTheme()

	const currentTheme = theme === 'AUTO' ? (isDarkMode ? 'DARK' : 'LIGHT') : (theme ?? 'LIGHT')

	return currentTheme === 'DARK'
}
